module.exports = {
  src: __webpack_public_path__ + "logo-tuv-ae3e77fb5f8f7029d84b9414107fe78f.svg",
  width: 74,
  height: 74,
  bytes: 20451,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-tuv-ae3e77fb5f8f7029d84b9414107fe78f.svg";
};